import { apiPost, apiGet, apiDelete } from "./api.service";

export async function submitFeedback(message) {
    return apiPost('/feedback', { message });
}

export async function fetchFeedback() {
    return apiGet('/admin/feedback');
}

export async function deleteFeedback(id) {
    return apiDelete(`/admin/feedback/${id}`);
}